<template>
    <div class="seo-text">
        <div class="seo-text__main-headline" v-if="seoTextMainHeadline != ''">{{ seoTextMainHeadline }}</div>
        <div class="seo-text__collapsable" ref="collapsableText" v-html="seoText"></div>
        <a v-if="seoText.length > 0" href="#" class="seo-text__collapse-toggle" @click.prevent="toggleText()">{{ $translate("ODStylebreaker::Template.showMore") }}</a>
    </div>
</template>
<script>
    export default {
        props: {
            bemclass: {
                type: String,
                default: ""
            },
            seoText: {
                type: String,
                default: ""
            },
            seoTextMainHeadline: {
                type: String,
                default: ""
            }
        },

        computed:{
            isHome(){
                return App.templateEvent === "tpl.home.category";
            }
        },

        methods: {
            toggleText(){
                $(this.$refs.collapsableText).toggleClass('is-open');
            }
        }
    }
</script>
